module.exports = __webpack_public_path__ + "resources/img/img-zenius-ems-02-m.5df206547fffd63352e9c12d0ac9ce62.png";